import { CmsPageTypeEnumDTO } from '@auto-generated/ap-platform/users';

export const CmsPageTypeUrl = {
	FAQ: 'faq' as CmsPageTypeEnumDTO,
	TERMS_AND_CONDITIONS: 'terms-and-conditions' as CmsPageTypeEnumDTO,
	PRIVACY: 'privacy' as CmsPageTypeEnumDTO,
	IMPRESSIONS: 'imprint' as CmsPageTypeEnumDTO,
	CONTACT: 'contact' as CmsPageTypeEnumDTO,
	LICENSES: 'licenses' as CmsPageTypeEnumDTO,
	RELEASENOTES: 'news' as CmsPageTypeEnumDTO
};

export const BookingPageTypeArray: Array<CmsPageTypeEnumDTO> = [
	CmsPageTypeEnumDTO.PRIVACY,
	CmsPageTypeEnumDTO.TERMSANDCONDITIONS,
	CmsPageTypeEnumDTO.IMPRESSIONS,
	CmsPageTypeEnumDTO.CONTACT,
	CmsPageTypeEnumDTO.LICENSES
];

export const AdminPageTypeArray: Array<CmsPageTypeEnumDTO> = [
	CmsPageTypeEnumDTO.PRIVACY,
	CmsPageTypeEnumDTO.TERMSANDCONDITIONS,
	CmsPageTypeEnumDTO.IMPRESSIONS,
	CmsPageTypeEnumDTO.FAQ,
	CmsPageTypeEnumDTO.LICENSES,
	CmsPageTypeEnumDTO.RELEASENOTES
];
